interface GetWeekCardStateProps {
  cardWeekNumber: number
  activeWeekNumber: number | null
  isCurrentPreview: boolean
}

export const getWeekCardState = ({
  cardWeekNumber,
  activeWeekNumber,
  isCurrentPreview
}: GetWeekCardStateProps) => ({
  isCurrentWeek: isCurrentPreview,
  isSelected: activeWeekNumber === cardWeekNumber
})
